import {
  fetchGetPaymentMethod,
  fetchDeletePaymentMethod,
} from '@iwoca/lapi-client/edge';
import { useMutation, useQuery } from '@tanstack/react-query';

import { useStateKey } from './useStateKey.hook';

export function usePaymentMethod() {
  const { stateKey } = useStateKey();

  const { data, isLoading } = useQuery({
    queryKey: ['fetchGetPaymentMethod'],
    queryFn: () => fetchGetPaymentMethod({ stateKey: stateKey! }),
    enabled: Boolean(stateKey),
  });

  const firstPaymentMethod = data?.data[0];

  return {
    bankDetails: firstPaymentMethod?.bank_details || {
      account_number: undefined,
      sort_code: undefined,
    },
    isLoading: isLoading,
  };
}

export function usePaymentMethodCard() {
  const { stateKey } = useStateKey();

  const { data, isLoading } = useQuery({
    queryKey: ['fetchGetPaymentMethod'],
    queryFn: () => fetchGetPaymentMethod({ stateKey: stateKey! }),
    enabled: Boolean(stateKey),
    refetchOnMount: 'always',
  });

  const firstPaymentMethod = data?.data.find(
    (card) =>
      card.roles.repayment === 'primary' && card.payment_method_type === 'card',
  );

  return {
    id: firstPaymentMethod?.payment_method_id,
    brand: firstPaymentMethod?.brand,
    expiryDate:
      firstPaymentMethod?.expires?.month && firstPaymentMethod?.expires?.year
        ? `${firstPaymentMethod?.expires?.month}/${firstPaymentMethod?.expires?.year.toString().substring(2)}`
        : undefined,
    lastFourDigits: firstPaymentMethod?.last_digits?.toString(),
    isLoading,
  };
}

export function useDeletePaymentMethodCard() {
  const { stateKey } = useStateKey();

  return useMutation({
    mutationFn: async (paymentMethodId: string | undefined) => {
      if (!stateKey || !paymentMethodId) return;
      return await fetchDeletePaymentMethod({
        stateKey,
        paymentMethodId,
      });
    },
  });
}
